import { render } from "./dialogConfirmByPass.vue?vue&type=template&id=45471b08&scoped=true"
import script from "./dialogConfirmByPass.vue?vue&type=script&lang=js"
export * from "./dialogConfirmByPass.vue?vue&type=script&lang=js"

import "./dialogConfirmByPass.vue?vue&type=style&index=0&id=45471b08&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45471b08"]])

export default __exports__